import { useLocation } from 'react-router-dom';

// Returns '/fr' when the current URL is under the French mirror (see
// components/LanguageForcer and the /fr/* routes in App.js), else ''.
// Pages use this to build a canonical path that matches their actual URL
// instead of hardcoding the AR/EN shared path.
export default function useLangPrefix() {
  const { pathname } = useLocation();
  return pathname === '/fr' || pathname.startsWith('/fr/') ? '/fr' : '';
}
